export default __webpack_public_path__ + "static/media/pickshare-abbinder.68c671ca.jpg";